"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getByAffaireId = getByAffaireId;
exports.getById = getById;
exports.update = update;
exports.insert = insert;
exports.deleteById = deleteById;
exports.bulkDelete = bulkDelete;

var _request = _interopRequireDefault(require("@/helpers/request"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getByAffaireId(idAffaire) {
  return (0, _request.default)({
    url: '/commentaire/affaire/' + idAffaire,
    method: 'get'
  });
}

function getById(id) {
  return (0, _request.default)({
    url: '/commentaire/' + id,
    method: 'get'
  });
}

function update(id, data) {
  return (0, _request.default)({
    url: '/commentaire/' + id,
    method: 'put',
    data: data
  });
}

function insert(data) {
  return (0, _request.default)({
    url: '/commentaire',
    method: 'post',
    data: data
  });
}

function deleteById(id) {
  return (0, _request.default)({
    url: '/commentaire/' + id,
    method: 'delete'
  });
}

function bulkDelete(ids) {
  return (0, _request.default)({
    url: '/commentaire/' + ids,
    method: 'delete'
  });
}